module.exports = __webpack_public_path__ + "09db78768f0305741cc01ed0674b1328.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1/public/team/Leadership_Justin_0.jpg
// module id = 421
// module chunks = 0